import React, {Fragment, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getNotificationTemplates} from "../../../Api/ApiCalls";
import {handleError} from "../../../utils/SharedFunctions";

const NotificationTemplatesListPage = () => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const response = await getNotificationTemplates();
            setTemplates(response);
        } catch (error) {
            console.error("Error fetching notification templates:", error);
            handleError(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchTemplates().then();
    }, []);

    return (
        <Fragment>
            <div className="row justify-content-center">
                <div className="col-xl-12 col-xxl-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title mb-0">Push Notification Templates</h4>
                        </div>
                        <div className="card-body">
                            {loading ? (
                                <p>Loading...</p>
                            ) : (
                                <table className="table dataTable display">
                                    <thead>
                                    <tr>
                                        <th>Template Name</th>
                                        <th>Title (EN)</th>
                                        <th>Title (NL)</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {templates.length ? (
                                        templates.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.templateKey}</td>
                                                <td>{item.titleEn}</td>
                                                <td>{item.titleNl}</td>
                                                <td>
                                                    <Link
                                                        to={`/notification-templates/edit/${item.id}`}
                                                        className="btn btn-sm btn-secondary"
                                                    >
                                                        Edit
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                No templates found.
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default NotificationTemplatesListPage;
